<template>
  <div>

    <div class="row mt-4">
      <div class="col-md-8">
        <input class="input form-control"
               @keypress.enter="$emit('findGeneric', generic)"
               v-model="generic"
               placeholder="Pesquisar por mesagem">
        <search-icon @click="$emit('findGeneric', generic)" class="icon icon-within"/>
      </div>

      <button class="col-md-1 ml-2 btn-sm btn-outline" @click="$emit('newXmlAuthenticator')">
        Novo
      </button>

    </div>

    <div class="row">
      <div class="col-sm-12">

        <div class="row mt-4">
          <div class="col-md-12">
            <strong>
              {{infoTotalModels}}
            </strong>
          </div>
        </div>

        <table class="table table-borderless table-align table-h51">
          <thead>
            <tr>
              <th>Nome</th>
              <th>Descrição</th>
              <th>Criado por</th>
              <th>Criado em</th>
              <th>Atualizado por</th>
              <th>Atualizado em</th>
              <th>Quantidade de empresas</th>
              <th>Ativo</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="group in groups" :key="group.id">
              <td>{{ group.name }}</td>
              <td>{{ group.description }}</td>
              <td>{{ group.createdBy }}</td>
              <td>{{ group.createdAt | datetime }}</td>
              <td>{{ group.updatedBy }}</td>
              <td>{{ group.updatedAt | datetime }}</td>
              <td>{{ group.companyIds && group.companyIds.length }}</td>
              <td>
                {{ group.enable ? 'Sim' : 'Não' }}
              </td>
              <td>
                <button class="btn btn-outline mr-2" @click="editXmlAuthenticator(group)">
                  {{ 'btn.edit' | t }}
                </button>
                <button class="btn btn-outline-red" @click="deleteXmlAuthenticator(group)">
                  {{ 'btn.delete' | t }}
                </button>
              </td>
            </tr>
          </tbody>
        </table>

        <div class="row">
          <div class="col-md-12 my-1">
            <Pagination
              v-model="meta.currentPage"
              :total-count="meta.totalCount"
              :total-pages="meta.totalPages"
              @pagination="$emit('pagination', $event)"
            />
          </div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
  import Pagination from '@/components/shares/specialTag/Pagination'
  import { SearchIcon } from 'vue-feather-icons'

  export default {
    components: { Pagination, SearchIcon },
    computed: {
      groups() {
        return this.xmlAuthenticators.map(x => x.group)
      }
    },
    data() {
      return {
        generic: ''
      }
    },
    methods: {
      deleteXmlAuthenticator(group) {
        const xmlAuthenticator = this.xmlAuthenticators.find(x => x.group === group)
        this.$emit('deleteXmlAuthenticator', xmlAuthenticator)
      },
      editXmlAuthenticator(group) {
        const xmlAuthenticator = this.xmlAuthenticators.find(x => x.group === group)
        this.$emit('editXmlAuthenticator', xmlAuthenticator)
      }
    },
    name: 'Index',
    props: {
      infoTotalModels: { require: true },
      meta: { required: true, type: Object },
      xmlAuthenticators: { required: true, type: Array }
    }
  }
</script>

<style scoped>

</style>